import {
  Card,
  CardContent,
  Typography,
  ButtonGroup,
  Select,
  MenuItem,
} from '@material-ui/core';
import moment from 'moment';
import { createStructuredSelector } from 'reselect';
import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { PAGES } from 'routes';
import { connect } from 'react-redux';
import { isEmpty, get } from 'lodash';
import NavigationButtons from 'components/navigationButtons';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import CloseIcon from 'components/SahamIcons/Close';
import { pushTo } from 'containers/services/routes-helper';
import { translate } from 'containers/services/translate';
import messages from 'containers/UploadDocumentsManager/messages';
import upload from 'images/upload.svg';
import { uploadDocument } from 'containers/UploadDocumentsManager/actions';
import { makeSelectDocument } from 'containers/UploadDocumentsManager/selectors';
import Stepper from 'containers/AppContainer/Stepper';
import { makeSelecClaimToPreopen } from 'containers/PreOpeningPage/selectors';
import { DOCUMENT, EMPTY_DOCUMENT } from 'containers/data-structure';
import { setClaim } from 'containers/PreOpeningPage/actions';
import { DEFAULT_DOCUMENT_TYPE } from 'containers/UploadDocumentsManager/constants';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import {
  openDocument,
  getLiveDocumentViewUrl,
  formatDocument,
  toDataUrl,
} from 'containers/UploadDocumentsManager/utils';
import { fileSelectHandler } from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import {
  startLoading,
  stopLoading,
} from 'containers/AppContainer/Loader/action';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import {
  StyledDiv,
  Container,
  BootstrapInput,
  StyledDivUpload,
} from 'containers/UploadDocumentsManager/styles';

export interface UploadDocumentsManagerProps {
  intl: IntlShape;
  uploadDocument: Function;
  uploadedDocument: { response: string } | {};
  storedClaimToPreopen: any;
  setClaim: Function;
  claimInfo: any;
  startLoading: Function;
  stopLoading: Function;
  loaders: any;
}

const UploadDocumentsManager: React.FC<UploadDocumentsManagerProps> = (
  props,
): JSX.Element => {
  const isPreOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISPREOPENMANAGER,
  );
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  const isCourtManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCOURTMANAGER,
  );

  React.useEffect(() => {
    if (isEmpty(props.storedClaimToPreopen)) {
      isPreOpeningManager
        ? pushTo(PAGES.PREOPEN_MANAGER_HOME)()
        : pushTo(PAGES.MANAGER_HOME)();
    }
  });
  const [uploadedDocs, setUploadedDocs] = React.useState<any[]>([
    ...get(props.storedClaimToPreopen, 'documents', []),
  ]);
  const [isMyAutoPv, setIsMyAutoPv] = React.useState<any>(false);
  const [documentumId, setDocumentumId] = React.useState<any>(null);
  const [indexedAt, setIndexedAt] = React.useState<any>(null);

  const [documentType, setDocumentType] = React.useState(DEFAULT_DOCUMENT_TYPE);

  const fileRef: React.RefObject<HTMLInputElement> = React.createRef();

  const uploadClick = () => {
    fileRef.current?.click();
  };

  const failedCallBack = () => {
    setIsMyAutoPv(false);
  };

  useEffect(() => {
    const uploadFileSagis = async () => {
      props.startLoading();
      if (!isEmpty(formatDocument(props.claimInfo))) {
        const PVDOC = formatDocument(props.claimInfo).find(
          el => el.type === 'PV' || el.DocumentType === 'PV',
        );
        if (!isEmpty(PVDOC) && !isMyAutoPv) {
          const doc = getLiveDocumentViewUrl(
            PVDOC.path,
            PVDOC.fileName,
            PVDOC.isIndexed,
            PVDOC.documentId,
          );
          const base64 = await toDataUrl(doc);
          props.uploadDocument(base64, failedCallBack);
          setIsMyAutoPv(true);
          setDocumentumId(PVDOC.documentId);
          setIndexedAt(PVDOC.dateDeCreation);
        }
      }
      props.stopLoading();
    };
    uploadFileSagis();
  }, [props.claimInfo]);

  useEffect(() => {
    const documents = [...uploadedDocs];
    const newDocument: any = {
      ...EMPTY_DOCUMENT,
      [DOCUMENT.IS_INDEXED]: isMyAutoPv,
      [DOCUMENT.IS_VISIBLE]: true,
      [DOCUMENT.NAME]: `${translate(
        { ...messages.uploadedDocument },
        props,
      )} ${uploadedDocs.length + 1}`,
      [DOCUMENT.TYPE]: documentType,
      [DOCUMENT.URL]: get(props.uploadedDocument, 'response'),
      documentumId: isMyAutoPv ? documentumId : null,
      indexedAt: isMyAutoPv ? moment(indexedAt).toISOString(true) : null,
    };

    const isPresent = uploadedDocs.filter(
      (doc: { url: string }) => doc.url === newDocument[DOCUMENT.URL],
    );

    if (isPresent.length === 0 && !isEmpty(props.uploadedDocument)) {
      documents.push(newDocument as never);
    }

    setUploadedDocs(documents);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.uploadedDocument]);
  const isUsageOpening =
    featureService.hasFeature(FEATURES.OPENING_BY_USAGE) &&
    isPreOpeningManager &&
    get(props, 'location.state.isUsageOpening', false);
  const storeUploadDocument = () => {
    const storedClaim = { ...props.storedClaimToPreopen };
    storedClaim.documents = uploadedDocs;
    props.setClaim(storedClaim);
    isPreOpeningManager
      ? pushTo(PAGES.RECAPITULATIF_PREOPEN_MANAGER, {
          isUsageOpening: isUsageOpening,
        })()
      : !get(props, 'location.state.isFromSagis') ||
        !(
          featureService.hasFeature(FEATURES.BASIC_MANAGEMENT) ||
          featureService.hasFeature(FEATURES.BASIC_MANAGEMENT_REGULATION)
        )
      ? pushTo(PAGES.RECAPITULATIF_MANAGER)()
      : pushTo(PAGES.PREOPENING_MANAGER_RECAPITULATIF, {
          isFromSagis: true,
          sagisInfoClaim: get(props, 'location.state.sagisInfoClaim'),
        })();
  };

  const deleteDocument = (index: number) => () => {
    const documents = [...uploadedDocs];
    documents.splice(index, 1);
    setUploadedDocs(documents);
  };
  const handleChangeSelected = (e: React.ChangeEvent<{ value: unknown }>) => {
    setDocumentType(e.target.value as string);
  };

  return (
    <div>
      <Stepper
        isOpeningManager={isOpeningManager}
        isPreOpeningManager={isPreOpeningManager}
        isCourtManager={isCourtManager}
        isBasicManagement={get(props, 'location.state.isFromSagis')}
      />
      <StyledDiv>
        {translate({ ...messages.UploadDocumentsTitle }, props)}
      </StyledDiv>
      <Container className="container">
        <StyledDivUpload>
          <span className="titleDoc">
            {translate(
              { ...messages.uploadDocumentsPageUploadDivTitle },
              props,
            )}
          </span>
          <div className="uploadInput">
            <Typography className="label">
              {translate(
                { ...messages.uploadDocumentsPageUploadDivSubTitle },
                props,
              )}
            </Typography>
            <ButtonGroup className="group" component="form">
              <Select
                className="input"
                value={documentType}
                onChange={handleChangeSelected}
                input={<BootstrapInput />}
              >
                <MenuItem value="PV">{DEFAULT_DOCUMENT_TYPE}</MenuItem>
                {isUsageOpening && (
                  <MenuItem value="Document de base">
                    {'Document de base'}
                  </MenuItem>
                )}
              </Select>
              <input
                id="selectImage"
                type="file"
                onChange={fileSelectHandler(props.uploadDocument, props)}
                ref={fileRef}
                hidden
              />

              <PrimaryButton
                className="button"
                variant="contained"
                disableElevation
                data-testid="upload-btn"
                onClick={uploadClick}
                title={translate({ ...messages.uploadDocumentBtn }, props)}
                lefticon={<img src={upload} alt="null" />}
              />
            </ButtonGroup>
          </div>
        </StyledDivUpload>
        <Card>
          <CardContent>
            <span className="title">
              {isMyAutoPv
                ? translate(
                    { ...messages.UploadDocumentsMyAutoSubTitle },
                    props,
                  )
                : translate({ ...messages.UploadDocumentsSubTitle }, props)}
            </span>
            <div className="uploaded-docs-div">
              {uploadedDocs.map((document, index) => {
                return (
                  <div className="documentContainer" key={index}>
                    <div className="documentTypeContainer">
                      <span className="documentType">
                        {get(document, 'type')}
                      </span>
                      <div
                        className="iconStyle"
                        onClick={deleteDocument(index)}
                      >
                        <CloseIcon />
                      </div>
                    </div>
                    <span
                      className="documentTitle"
                      onClick={openDocument(document?.url)}
                    >
                      {get(document, 'name')}
                    </span>
                  </div>
                );
              })}
            </div>
          </CardContent>
        </Card>
      </Container>
      <NavigationButtons
        onPreviousClick={
          isPreOpeningManager
            ? pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER, {
                isUsageOpening: get(
                  props,
                  'location.state.isUsageOpening',
                  false,
                ),
              })
            : isCourtManager && get(props, 'location.state.isFromSagis')
            ? pushTo(PAGES.PREOPENING_MANAGER, {
                isFromSagis: true,
                sagisInfoClaim: get(props, 'location.state.sagisInfoClaim'),
                isUsageOpening: get(
                  props,
                  'location.state.isUsageOpening',
                  false,
                ),
              })
            : !get(props, 'location.state.isFromSagis') ||
              !featureService.hasFeature(FEATURES.BASIC_MANAGEMENT)
            ? pushTo(PAGES.OPENING_CLAIM)
            : get(props, 'location.state.isFromSagis')
            ? pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER, {
                isUsageOpening: get(
                  props,
                  'location.state.isUsageOpening',
                  false,
                ),
              })
            : pushTo(PAGES.PREOPENING_MANAGER, {
                isFromSagis: true,
                sagisInfoClaim: get(props, 'location.state.sagisInfoClaim'),
              })
        }
        forwardClick={storeUploadDocument}
        disabledMoveButton={isEmpty(uploadedDocs)}
      />
    </div>
  );
};
const mapDispatchToProps = {
  uploadDocument,
  setClaim,
  startLoading,
  stopLoading,
};
const mapStateToProps = createStructuredSelector({
  uploadedDocument: makeSelectDocument(),
  storedClaimToPreopen: makeSelecClaimToPreopen(),
  claimInfo: makeSelectSearchClaims(),
  loaders: selectedLoader,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(UploadDocumentsManager));
